export const m = {
    about: '約',
    Qualification: '資格',
    LegalDocument: '法的文書',
    Partners: '相棒',
    ContactUs: 'お問い合わせ',
    Trade: 'トレード',
    IEO: 'IEO',
    OTC: 'OTC',
    News: 'ニュース',
    Announcement: '発表',
    IndustryNews: '業界ニュース',
    Assets: '資産',
    Personalcenter: 'パーソナルセンター',
    logout: 'サインアウト',
    login: 'ログイン',
    register: '登録',
    Exchange: '両替',
    LVOSubscribe: '購読する',
    Notice: '通知',
    Tradingpair: '取引ペア',
    Latestprice: '最新の価格',
    hChange: '24時間変更',
    hHigh: '24時間高',
    hLow: '低24時間',
    hVolume: '24時間ボリューム',
    Deal: '対処',
    gBlockchain: 'グローバルブロックチェーンアセットトレーディングプラットフォーム',
    ReliableSystem: '信頼できるシステム',
    RelGuaranteestem: 'トランザクションの安全で安定した効率的な運用を保証する',
    Elitewor: '世界のトップタレントのエリートチーム',
    Safetyfund: '資金の安全',
    encryption: 'HTTPSデータの暗号化、ID検証',
    encryptarchitectureion: 'コールドウォレットストレージ、財務レベルのアーキテクチャ、複数のセキュリティ保護',
    eexperienceon: '最高の体験',
    eeMultilingualn: '迅速な引き出し、多言語対応',
    Highperformance: '高性能取引エンジン、高速取引経験',
    Professionalservices: 'プロフェッショナルサービス',
    Professiinternational: 'プロフェッショナルな国際サービスチーム',
    problemsal: 'ユーザーの問題にタイムリーに対応する',
    Anywhere: 'トレード。どこでも。',
    cryptocurrencye: "あなたの手のひらの上で、Cornucopiaの暗号通貨交換のすべての力。 Cornucopiaモバイル暗号取引アプリを今すぐダウンロードしてください。",
    cryTradingcye: "今すぐ取引を開始",
    Deposi: "預り金",
    Help: "助けて",
    Registernow: "今すぐ登録",
    trading: "取引を開始する",
    Beginnerguide: "初心者向けガイド",
    FAQ: "よくある質問",
    FADigitalQ: "デジタルアセットの紹介",
    PrivacyPolicy: "個人情報保護方針",
    Disclaimer: "免責事項",
    UserAgreement: "ユーザー規約",
    Mail: "郵便物",
    Address: "住所",
    Unitedsta: "アメリカ合衆国ニューヨーク",
    UniDigitaltedsta: "デジタル資産は、価格変動が大きく投資リスクが高い革新的な投資商品です。投資する前に、デジタル資産を十分に認識し、その投資能力を合理的に判断し、慎重な投資決定を行ってください。",
    Risktips: "リスクのヒント",
    COMMITTED: "私たちは、ボックチェインプロジェクトの支援により資金を調達し、支援者を見つけ、新鮮で興味深い優れたアイデアを実現することを約束します。",
    CURRENCY: "新しい通貨ラッシュ",
    CURInformationNCY: "LVO-トークン情報",
    CURInformatiFVG: "FVG-トークン情報",
    CURInformatcvv: "CVV-トークン情報",
    Circulation: "サーキュレーション",
    Liquidity: "流動性",
    Initialprice: "初期価格",
    Lockcycle: "ロックサイクル",
    Deadline: "締め切り",
    DeaSubscrip: "サブスクリプションのカウントダウン",
    Subscribe: "申し込む",
    SessionTicket: "LVO-USDTサブスクリプションが進行中です",
    SOperatingt: "LVO-DAppベースのオペレーティングシステム",
    Price: "発行価格",
    SessionSupply: "合計サブスクリプション金額",
    Sessipaper: "プロジェクトホワイトペーパーをダウンロードする",
    Requirements: "プロジェクト参加条件",
    Reqcompleteents: "トークン発行者の要件を満たすには、すべてのユーザーがアカウントの確認を完了する必要があります",
    Pleaseents: "サインインしてください",
    ProjectIntroduction: "プロジェクトの説明",
    Keyfeatures: "主な特徴",
    Purposeof: "の目的",
    TOKENALLOCATION: "トークン配布",
    TOKENSCHEDULE: "トークン発行スケジュール",
    MyAssets: "私の資産",
    Withdrawhistory: "入出金記録",
    SubscribeHistory: "サブスクリプションレコード",
    Capitalflow: "資本の流れ",
    Deposit: "充電",
    TotalAssets: "総資産",
    Toconversionsets: "注：総資産換算は市場の見積もりに基づいて推定されており、ユーザーのための参考値です",
    SmallBalances: "小資産通貨を非表示にする",
    Currency: "通貨",
    Total: "合計",
    Available: "利用可能",
    Frozen: "氷結",
    Description: "オペレーティング",
    Withdraw: "出金",
    WithdrawAddress: "出金住所",
    WithdrawAmount: "引き出し回数",
    ServiceCharge: "サービス料",
    Amountarrival: "入荷数量",
    fundpwd: "資金パスワード",
    Tips: "注意",
    minimum: "最小引き出し金額は",
    musuallyum: "引き出しは通常2〜24時間で完了し、到着時にメールで通知されます。資金の安全を確保するために、アカウントのセキュリティポリシーが変更された場合、パスワードが変更された場合、または新しいアドレスを使用して引き出した場合は、手動による確認を行います。しばらくお待ちください。スタッフから電話またはメールでご連絡いたします。",
    muconfirmyum: "情報の改ざんや漏洩を防止するために、コンピューターとブラウザーのセキュリティを確認してください。",
    forbiddenum: "Cornucopiaプラットフォームの口座間での入金・出金は禁じられており、必要に応じて振込が可能です。 ",
    DepositAddress: "入金アドレス",
    Copy: "写す",
    blockchainCopy: "補充しました",
    confirmnCopy: "情報の改ざんや漏洩を防止するために、コンピューターとブラウザーのセキュリティを確認してください。",
    forbidden: "Cornucopiaプラットフォームの口座間での入金・出金は禁じられており、必要に応じて振込が可能です。",
    Type: "の種類",
    Startt: "開始時間",
    EndTime: "終了時間",
    QUERY: "問い合わせる",
    Amount: "量",
    Balance: "残高",
    Time: "時間",
    Status: "状態",
    Commissions: "総合サービス料",
    Blockchainid: "ブロックチェーンID",
    Ins: "バラエティ",
    TotalValue: "総価値",
    newcurrency: "新通貨定期購読",
    Tokeninformation: "トークン情報",
    Day: "日",
    Dsubscriptionay: "あなたの購読",
    Pleaseonay: "通帳に入力してください",
    availablebalance: "利用可能残高",
    All: "すべて",
    SUBMIT: "提出済み",
    SUWelcomeBMIT: "お帰りなさい、あなたのユーザー情報を入力してください",
    Account: "アカウント",
    Password: "パスワード",
    ForgetPassword: "パスワードを忘れた",
    notForaccount: "まだアカウントを持っていないのですか",
    Signnow: "今すぐ登録",
    Welcomejois: "ご参加へようこそ",
    Phone: "電話",
    Email: "メールボックス",
    Nationality: "国籍",
    LoginPassword: "パスワード",
    ConfirmPassword: "パスワードの確認",
    VerificationCode: "検証コード",
    InvitationCode: "招待コード",
    Ihavereae: "を読みました",
    Useragreement: "「利用規約」",
    Existingaccount: "すでにアカウントをお持ちですか",
    Loginimmediately: "今すぐサインイン",
    BasicInformation: "基本情報",
    MyAccount: "マイアカウント",
    Nickname: "ニックネーム",
    Change: "修正",
    UserID: "ユーザーID",
    FundPassword: "資金パスワード",
    FResetssword: "資金パスワードをリセット",
    Noteoriginal: "注：リセット後、元のファンドパスワードは破棄され、新しいパスワードがトランザクションに使用されます。",
    DoubleAuthentication: "二要素認証",
    Bind: "練る",
    Edit: "編集する",
    Verification: "確認済み",
    licensetype: "証明書の種類",
    name: "名前",
    licensenumber: "ID番号",
    PaymentAccount: "売掛金",
    Add: "追加",
    Apaymentdd: "受け取りアカウントを設定していません",
    Delete: "削除",
    LoginHistory: "ログイン履歴",
    Loginmethod: "ログイン方法",
    IP: "IPアドレス",
    Riskdisclosurebook: "リスク開示書",
    chinaz: "日本語",
    LatestNews: "最新ニュース",
    updatesnse: "リアルタイム更新、一次資料、リアルタイム解読",
    Curency: "为替",
    Curplatformency: "世界最高の総合取引プラットフォーム",
    digitalency: "安全、公平、透明な環境における取引差額契約",
    coinsency: "取引差額契約の最適な場所",
    coIntegrationency: "金融とテクノロジーの統合",
    basictionency: "強力な基本的な金融およびトランザクションインフラストラクチャ、マルチレイヤーおよびマルチクラスターシステムアーキテクチャの採用、システムのセキュリティと安定性の大幅な向上、AIテクノロジー、マイクロサービス分割の設計とアプリケーション、トランザクションの安全率のインテリジェントな向上",
    bandency: "高速で簡潔な取引システム",
    basystemcy: "メガビットメモリマッチングシステム、正確で高速なトランザクションオーダーの実行、コアトランザクションの低レイテンシ",
    eliteemcy: "プロのエリートチーム",
    capabiqlities: "トップブロックチェーン、金融、AIの分野の実務家は、新規およびパーソナライズされたビジネス向けの強力な迅速な開発機能を備えた専門家チームを作成し、7 * 24時間の多言語カスタマーサービスサポートを提供します",
    fairities: "安全、公正、透明な取引環境",
    regulatoryties: "複数の国からの金融規制ライセンスを保持し、米国財務省のデジタル比率取引ライセンスを取得します",
    CFDtrading: 'CFD取引',
    CFDtmajorng: '比較的低いマージンと手数料で暗号通貨などの主要なアクティブな市場と品種を取引する',
    ICOransaction: 'ICO外貨両替取引',
    Supportmajorng: '世界の主流の暗号通貨の外貨両替取引をサポートする',
    OTCansaction: 'OTC店頭取引',
    otcajorng: '主流の暗号通貨との外貨両替をサポートする',
    Blockchnsaction: 'ブロックチェーンウォレット',
    Blockchjorng: 'ブロックチェーン分散化テクノロジーを使用して、資産の安全な管理と便利な流通を実現します',
    Beginorng: 'すぐにVMISLで取引を開始します',
    LetBeginorng: '安心して取引できるようになります',
    LOpeninorng: '口座を開設する',
    stableorng: '迅速で安定した取引プラットフォーム',
    sPlcgGObleorng: 'VMtrade一般投資家の優先順位',
    sPSimpleeorng: '簡単で、速く、使いやすいプラットフォームで、あらゆる種類のアイテムが手に入ります。VMtradeはwebベースのアプリケーションで、pcやモバイルでのwebログイン取引に適している。',
    ssuitableng: 'VMtradeはすべての投資家に適している',
    pWerovide: 'pcまたはモバイル端末にダウンロードしてインストールできる取引プラットフォームを提供しています。',
    accountide: 'アカウントを選択し、申請書を提出します',
    cardInvest: 'デビットカードまたは銀行カード振替で迅速かつ安全に資金を注入します。',
    Accesswr: '差引契約などの取引品目と取引方式にアクセスする。',
    Acinvestmentsswr: 'あなたの投資価値は上がるかもしれないし、下がるかもしれない。手付金取引では、損失が手付金を超えたり、元本の大部分を占めることもあります。高いレバレッジは高いリスクを意味し、あなたのリスクに耐える能力とレバレッジ取引の理解度を慎重に考慮する必要があります。',
    Arealizetsswr: 'リスクには取引のリスクだけでなく、ネットワークの中断、政治的混乱、ハッキングなどの不可抗力要因によるリスクも含まれていることを認識しなければなりません。',
    Parklifetsswr: 'VMISL(China Vision Capital(Hong Kong)Limited)SFC証券および先物取引監査委員会の監督管理、カード番号BII 154、照会リンクhttps://apps.sfc.hk/publicregWeb/searchByName?locale=zh',
    drtwebfetsswr: '本ウェブサイトは全世界でアクセス可能であり、本ウェブサイト上のすべての情報は参考目的であり、ガイドラインを構成するものではなく、本ウェブサイトまたは本ウェブサイトの情報に基づいて誰が取る行動または不行動の結果について、当社は責任を負いません。',
    webfetsswr: 'アプリをダウンロードする',
    home: 'トップページ',


    // 东盛新增
    selectsown: 'ダウンロード方法を選択してください。', 
    downffgdr: 'ローカルダウンロード',    
    downfsafgdr: 'ダウンロード',
    Qualification:'資質',
    licenseTitle:'SFC証券及び先物事務監査委員会の監督管理を受ける',
    licenseNumber:'カード番号',
    licenseLink:'クエリリンク',
    homeTheMost:'最も信頼されている金融派生品取引プラットフォーム',
    viewCertificate:'証明書を表示',

}


// WEBPACK FOOTER //
// ./src/common/lang/ri.js